import React from "react"
import BackgroundImage from "gatsby-background-image"
import useTranslation from "../../mlang/useTranslation"

const Samples = ({ images }) => {
  const t = useTranslation('equipment')

  return (
    <section className="samples">
      <h3>{t.samples}</h3>
      <div className="container">
        {images.map(({ image }) =>
          <div
            className="image__wrapper"
            key={image.fluid.originalName}>
            <BackgroundImage
              className="image"
              fluid={image.fluid}
              alt={image.fluid.originalName}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default Samples